import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'

import ShortInfo from './../block/ShortInfo'
import CardsLeftImage from './../block/CardsLeftImage'
import NashiRaboti from './../block/NashiRaboti'
import Konfiguraciya from './../block/Konfiguraciya'
import Advantages from './../block/AdvantagesV2'


import HideContentBlock from './../block/HideContentBlock'

class PlastikOkna extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <ShortInfo
          data={data?.short_info || {}}
          assets_path={assets_path}
        />
        <CardsLeftImage
          list={data?.cards_left_image}
          assets_path={assets_path}
        />
        <NashiRaboti
          list={data?.nashi_raboti}
          assets_path={assets_path}
        />
        <Konfiguraciya
          data={data?.konfiguraciya}
          assets_path={assets_path}
        />
        <Advantages
          advantages={data?.advantages || {}}
        />
        <HideContentBlock
          data={data?.hidecontent || {}}
          className={`y`}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

PlastikOkna.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

PlastikOkna.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default PlastikOkna